import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChange } from "@angular/core";
import { ToastrService } from "ngx-toastr";
import { TranslateService } from "@ngx-translate/core";
import { TextOperatorType } from "src/app/models/text-operator";
import { SelectOperatorType } from "src/app/models/select-operator";
import { ClassificationField } from "src/app/models/classification-field";
import { ClassificationGroup } from "src/app/models/classification-group";
import { FormControllerService } from "src/app/services/form-controller/form-controller.service";
import { Store } from "src/app/services/store.service";
import { FieldType } from "src/app/models/field-type";
import { SelectSubjectType } from "src/app/models/select-subject";
import { Determinant } from "src/app/models/determinant";
import { FileDeterminant } from "src/app/models/file-determinant";
import { BooleanDeterminant } from "src/app/models/boolean-determinant";
import { NumericDeterminant } from "src/app/models/numeric-determinant";
import { MoneyDeterminant } from "src/app/models/money-determinant";
import { TextDeterminant } from "src/app/models/text-determinant";
import { RadioDeterminant } from "src/app/models/radio-determinant";
import { SelectDeterminant } from "src/app/models/select-determinant";
import { SelectBoxesDeterminant } from "src/app/models/selectboxes-determinant";
import { DateDeterminant } from "src/app/models/date-determinant";
import { GridDeterminant } from "src/app/models/grid-determinant";
import { GroupingDeterminant } from "src/app/models/grouping-determinant";
import { ClassificationDeterminant } from "src/app/models/classification-determinant";
import { DeterminantType } from "src/app/models/determinant-type";
import * as _ from "lodash";
import { SubCatalogDeterminant } from "src/app/models/sub-catalog-determinant";
import { ButtonDeterminant } from "src/app/models/button-determinant";
import { FileUploadDeterminant } from "src/app/models/file-upload-determinant";
import { GridComponentDeterminant } from "src/app/models/grid-component-determinant";
import { TranslatedBaseError } from "../../../../TranslatedBaseError";
import { GeneralOperatorType } from "../../../../../../models/general-operator";
import { ExtOperator } from "../../../../../../models/ext-operator";
import { NumericOperatorType } from "src/app/models/numeric-operator";

@Component({
  selector: "formfield-determinant",
  templateUrl: "./formfield-determinant.component.html",
  styles: [],
  providers: [
    FormControllerService,
    ToastrService,
  ],
})
export class FormFieldDeterminantComponent extends TranslatedBaseError implements OnInit, OnChanges {
  private static NON_COMPONENT_FORM_TYPES = ["System variables"];

  @Input() public determinant: any;
  @Output() public determinantResponse = new EventEmitter();
  @Input() public serviceId: string;
  @Input() public name: string;
  @Input() public parentDeterminantFieldKey: string;
  @Input() public isFirstLevel: boolean = true;
  @Input() public fieldSelectionValues: any[] = [];
  @Input() public selectedField: any;
  @Input() public fields: any[] = [];
  @Input() public allFields: any[] = [];
  @Input() public targetFormFieldKey: string;
  @Input() public fieldClassificationTypeId: string;

  public determinantType: string = DeterminantType.FORMFIELD.toString();
  public id: string;
  public type = "";
  public sourceFormFieldKey: string;
  public operator: GeneralOperatorType | NumericOperatorType = GeneralOperatorType.EQUAL;
  public textOperator: TextOperatorType = TextOperatorType.EQUAL;
  public selectOperator: SelectOperatorType = SelectOperatorType.EQUAL;
  public classificationOperator: SelectOperatorType = SelectOperatorType.EQUAL;
  public numericValue: number;
  public moneyValue: number;
  public textValue: string;
  public dateValue: Date;
  public booleanValue: boolean = true;
  public selectValue: string;
  public parentClassificationTypeId: string;
  public classificationValue: ClassificationField;
  public parentCatalogValue: ClassificationField;
  public classificationFields: any[] = [];
  public multipleClassificationFields: any[] = [];
  public subCatalogValue: ClassificationField;
  public classificationGroup: ClassificationGroup;
  public isCatalogMultiple: boolean = false;
  public gdbCatalog: any;
  // public fieldSelectionValues: any[] = [];
  public targetFormFieldJsonPath: string;
  public isCurrentDate: boolean = false;
  public subject: SelectSubjectType = SelectSubjectType.NULL;
  public gridContexts: any[] = ["inside same grid", "outside the grid"];
  public gridContext: string = null;
  public isFromGrid: boolean = false;
  public rowDeterminant: Determinant;
  public buttonEventName: string;
  public buttonKey: string;
  public fileUploadEventName: string;
  public fileUploadKey: string;
  public gridEventName: string;
  public gridKey: string;
  public currentChildComponentType: string = null;

  constructor(
    private formControllerService: FormControllerService,
    public store: Store,
    public toastr: ToastrService,
    public translateService: TranslateService) {
    super(toastr, translateService);
  }

  public ngOnInit() {
    if (this.serviceId && this.isFirstLevel) {
      this.formControllerService.getFieldsWithSchemas(this.serviceId).subscribe((data) => {
        if (this.parentDeterminantFieldKey) {
          this.selectedField = this.determinant;
          this.targetFormFieldKey = this.determinant.key;
          // data = data.filter((item) => item.fullKey && item.fullKey.includes(this.parentDeterminantFieldKey + "_collection_"));
        }
        data.forEach((item: any) => {
          if (item.formName) {
            item.fullName = this.translate(item.formName) + "." + item.fullName;
          }
        });
        this.allFields = data;
        this.fields = data.filter((d) => {
          return d.key.indexOf("_child_") === -1 && d.type !== "catalog" && d.type !== "panel";
        });
        this.initDeterminant();
      });
    } else {
      if (!this.isFirstLevel && this.serviceId) {
        if (this.parentDeterminantFieldKey) {
          this.selectedField = this.determinant;
          this.targetFormFieldKey = this.determinant.key;
          // data = data.filter((item) => item.fullKey && item.fullKey.includes(this.parentDeterminantFieldKey + "_collection_"));
        }
      }
      console.log("FormFieldDeterminant: ngOnInit", this.selectedField, this.targetFormFieldKey, this.serviceId, this.isFirstLevel);
      this.initDeterminant();
    }
  }

  public ngOnChanges(changes: { [propName: string]: SimpleChange }) {
    console.log("---- ngOnChanges", changes, this.isFirstLevel);
    if (changes.name && changes.name.currentValue) {
      this.name = changes.name.currentValue;
      if (this.determinant && this.determinant.id && this.determinant.name !== changes.name.currentValue) {
        this.determinantResponse.emit(this.getDeterminant());
      }
    }
    // Handle determinant changes independently from name changes
    // This ensures initDeterminant() is called even when name is set first
    if (changes.determinant && changes.determinant.currentValue) {
      this.initDeterminant();
    }
  }

  public contextChanged(event: any) {
    if (event && event === "inside same grid") {
      this.subject = SelectSubjectType.NULL;
    } else if (event && event === "outside the grid" && !this.subject) {
      this.subject = SelectSubjectType.ALL;
    }
    this.determinantResponse.emit(this.getDeterminant());
  }

  public getFieldType(targetFormFieldKey: any = null): string {
    if (targetFormFieldKey?.type) {
      return this.convertFieldTypeToDeterminantType(targetFormFieldKey.type, targetFormFieldKey.parentCatalogField).toUpperCase();
    } else if (this.type) {
      return this.type.toUpperCase();
    } else {
      return null;
    }
  }

  public isFormComponent() {
    if (this.selectedField) {
      if (!this.selectedField.formType) {
        return false;
      }
      return !FormFieldDeterminantComponent.NON_COMPONENT_FORM_TYPES.includes(this.selectedField.formType);
    }
    if (!this.targetFormFieldKey) {
      return false;
    }
    return !this.targetFormFieldKey.startsWith("constant_");
  }

  public childComponent(targetFormFieldKey: any = null) {
    let type = this.getFieldType(targetFormFieldKey);
    console.log("childComponent initial type:", type, this.getFieldType(targetFormFieldKey), this.isFirstLevel);
    switch (type) {
      case "TEXT":
      case "TEXTFIELD":
      case "TEXTAREA":
      case "HIDDEN":
        type = "TEXT";
        break;
      case "BUTTON":
        type = "BUTTON";
        break;
      case "NUMERIC":
      case "NUMBER":
        type = "NUMERIC";
        break;
      case "MONEY":
        type = "MONEY";
        break;
      case "DATE":
      case "DATETIME":
        type = "DATE";
        break;
      case "BOOLEAN":
      case "CHECKBOX":
        type = "BOOLEAN"; break;
      case "SELECTION":
      case "SELECTBOXES":
      case "RADIO":
      case "CHECKBOXES":
        type = "SELECT";
        break;
      case "SUB_CATALOG":
        if (![SelectOperatorType.IN, SelectOperatorType.NOT_IN].includes(this.classificationOperator)) {
          type = "SUB_CATALOG";
          break;
        }
      case "CLASSIFICATION":
      case "GROUPING":
        type = "CATALOG";
        break;
      case "FILE":
        type = "FILE";
        break;
      default: {
        console.log("unkown field type: " + type + ", targetFormFieldKey: " + targetFormFieldKey);
        break;
      }
    }
    return type;
  }

  private updateCurrentChildComponentType() {
    this.currentChildComponentType = this.childComponent(this.selectedField);
  }

  public initDeterminant() {
    console.log("--- initDeterminant --- ", this.determinant, this.isFirstLevel);
    if (this.determinant != null && this.determinant.type != null && this.determinant.name != null) {
      let gridField = null;
      this.id = this.determinant.id;
      this.name = this.determinant.name;
      this.determinantType = this.determinant.determinantType;
      this.targetFormFieldKey = this.determinant.targetFormFieldKey || this.determinant.fullKey;
      this.targetFormFieldJsonPath = this.determinant.targetFormFieldJsonPath;
      this.sourceFormFieldKey = this.determinant.sourceFormFieldKey;
      this.type = this.convertFieldTypeToDeterminantType(this.determinant.type, "");
      // console.log("--- TYPE", this.type, this.determinant);
      // Check for new event determinants (discriminated by event name properties)
      if ((this.determinant as any).buttonEventName !== undefined) {
        const det = this.determinant as ButtonDeterminant;
        this.buttonEventName = det.buttonEventName;
        this.buttonKey = det.buttonKey;
      } else if ((this.determinant as any).fileUploadEventName !== undefined) {
        const det = this.determinant as FileUploadDeterminant;
        this.fileUploadEventName = det.fileUploadEventName;
        this.fileUploadKey = det.fileUploadKey;
      } else if ((this.determinant as any).gridEventName !== undefined) {
        const det = this.determinant as GridComponentDeterminant;
        this.gridEventName = det.gridEventName;
        this.gridKey = det.gridKey;
      } else if (this.type.toUpperCase() === FieldType.BOOLEAN) {
        const det = this.determinant as BooleanDeterminant;
        this.booleanValue = det.booleanValue;
      } else if (this.type.toUpperCase() === FieldType.NUMERIC) {
        const det = this.determinant as NumericDeterminant;
        this.operator = det.operator;
        this.numericValue = det.numericValue;
      } else if (this.type.toUpperCase() === FieldType.MONEY) {
        const det = this.determinant as MoneyDeterminant;
        this.operator = det.operator;
        this.moneyValue = det.moneyValue;
      } else if (this.type.toUpperCase() === FieldType.TEXT || this.type.toUpperCase() === FieldType.TEXTAREA || this.type.toUpperCase() === FieldType.TEXTFIELD) {
        const det = this.determinant as TextDeterminant;
        this.textOperator = det.operator;
        this.textValue = det.textValue ? det.textValue : "";
      } else if (this.type.toUpperCase() === FieldType.FILE) {
        const det = this.determinant as FileDeterminant;
        this.textOperator = det.operator;
      } else if (this.type.toUpperCase() === FieldType.HIDDEN) {
        const det = this.determinant as TextDeterminant;
        this.textOperator = det.operator;
        this.textValue = det.textValue;
      } else if (this.type.toUpperCase() === FieldType.SELECTION ||
        this.type.toUpperCase() === FieldType.RADIO) {
        const det = this.determinant as SelectDeterminant;
        this.selectOperator = det.operator;
        this.selectValue = det.selectValue;
      } else if (this.type.toUpperCase() === FieldType.SELECTBOXES) {
        const det = this.determinant as SelectBoxesDeterminant;
        this.selectOperator = det.operator;
        this.selectValue = det.selectValue;
        // this.targetFormFieldKey = /[^\_child\_]*/.exec(this.targetFormFieldKey)[0];
        this.targetFormFieldKey = this.targetFormFieldKey.split("_child_")[0];
        this.targetFormFieldJsonPath = det.targetFormFieldJsonPath;
      } else if (this.type.toUpperCase() === FieldType.DATE) {
        const det = this.determinant as DateDeterminant;
        this.operator = det.operator;
        this.dateValue = det.dateValue;
        this.isCurrentDate = det.isCurrentDate;
      } else if (this.type.toUpperCase() === FieldType.GROUPING) {
        const det = this.determinant as GroupingDeterminant;
        this.classificationOperator = det.operator || SelectOperatorType.EQUAL;
        this.subject = det.subject;
        if (!this.fieldClassificationTypeId) {
          this.fieldClassificationTypeId = det.classificationGroup && det.classificationGroup.classificationTypeId
            ? det.classificationGroup.classificationTypeId
            : det.classificationTypeId;
        }
        this.classificationGroup = det.classificationGroup;
        this.classificationFields = det.classificationFields;
        this.multipleClassificationFields = this.classificationFields;
        this.parentCatalogValue = det.classificationField;
      } else if (this.type.toUpperCase() === FieldType.CLASSIFICATION || this.type.toUpperCase() === "SELECT") {
        const det = this.determinant as ClassificationDeterminant;
        this.classificationOperator = det.operator || SelectOperatorType.EQUAL;
        this.subject = det.subject;
        this.classificationValue = det.classificationField;
        this.classificationGroup = det.classificationGroup;
        this.parentCatalogValue = det.classificationField; // if it is sub group determinant
        if (!this.fieldClassificationTypeId) { this.fieldClassificationTypeId = det.catalog; }
        this.classificationFields = [];
        if (det.classificationFieldIds) {
          det.classificationFieldIds.forEach((c) => {
            this.classificationFields.push(c);
          });
        }
        this.multipleClassificationFields = this.classificationFields;
      } else if (this.type.toUpperCase() === FieldType.SUB_CATALOG) {
        const det = this.determinant as SubCatalogDeterminant;
        this.classificationOperator = det.operator;
        this.subject = det.subject;;
        this.parentCatalogValue = det.parentCatalogField;
        this.subCatalogValue = det.subCatalogField;
        this.classificationFields = det.classificationFieldIds || [];
        this.multipleClassificationFields = this.classificationFields;
      } else if (this.type.toUpperCase() === FieldType.GRID) {
        const det = this.determinant as GridDeterminant;
        // console.log(det, this.determinant);
        this.subject = det.subject;
        this.gridContext = det.subject ? "outside the grid" : "inside same grid";
        this.rowDeterminant = _.cloneDeep(det.rowDeterminant);
        const obj = this.allFields.find((item) => item.key === det.targetFormFieldKey);
        if (obj) {
          this.targetFormFieldJsonPath = obj.jsonPath;
          this.isFromGrid = true;
        }
        gridField = this.allFields.find((f) => f.fullKey === this.determinant.rowDeterminant?.targetFormFieldKey);
        console.log(this.allFields, this.determinant, gridField);
        if (gridField) {
          this.selectedField = gridField;
        }
      }
      if (
        (this.determinant &&
          this.determinant.determinantType === "FORMFIELD") || (!this.isFirstLevel && this.determinant?.fullKey?.includes("_collection_"))
      ) {
        // GridComponentDeterminant (event-based) uses targetFormFieldKey, not gridField
        // GridDeterminant (row-condition) uses gridField from rowDeterminant
        const isGridComponentDeterminant = (this.determinant as any).gridEventName !== undefined;
        const keyToUse = (this.type !== FieldType.GRID || isGridComponentDeterminant) ? this.targetFormFieldKey : gridField?.key;
        const fullKeyToUse = (this.type !== FieldType.GRID || isGridComponentDeterminant) ? this.targetFormFieldKey : gridField?.fullKey;
        this.setFieldDeterminantTypeByKey(keyToUse);
        this.mapFieldSelectionValuesByKey(fullKeyToUse, true);
      }
      // Update cached child component type
      this.updateCurrentChildComponentType();
      console.log("--- initDeterminant end --- ", this.determinant, this.type, this.targetFormFieldKey);
    }
  }

  public setFieldDeterminantTypeByKey(key: string) {
    this.fields.some((item) => {
      console.log("setFieldDeterminantTypeByKey checking item:", item.key, key);
      if (item.key === key || item.fullKey === key) {
        this.setFieldDeterminantType(item);
        return true;
      }
    });
  }

  public setFieldDeterminantType(field: any) {
    const fullKey = field.fullKey?.replace("_collection_item", "");
    if (field && fullKey?.includes("_collection_") && this.isFirstLevel) {
      this.type = FieldType.GRID;
      console.log("--- setFieldDeterminantType: is grid");
    } else if (field && fullKey?.includes("_collection_") && !this.isFirstLevel && this.validateType(field.type)) {
      this.type = FieldType.CLASSIFICATION;
      console.log("--- setFieldDeterminantType: is classification inside grid", field.type, this.validateType(field.type));
    } else if ((this.classificationOperator.toString() === SelectOperatorType.IN.toString() ||
      this.classificationOperator.toString() === SelectOperatorType.NOT_IN.toString()) &&
      (this.type === FieldType.GROUPING || this.type === FieldType.CLASSIFICATION ||
        field.type === "select")) {
      this.type = FieldType.GROUPING;
      console.log("--- setFieldDeterminantType: is grouping due to IN/NOT IN operator");
    } else if (!field) {
      this.type = "";
      console.log("--- setFieldDeterminantType: no field provided, type set to empty");
    } else {
      this.type = field.type ? field.type : field.type;
      console.log("--- setFieldDeterminantType: type set to", this.type);
    }
    this.type = this.convertFieldTypeToDeterminantType(this.type, field.parentCatalogField);
    console.log("--- setFieldDeterminantType:", field, this.type, this.classificationOperator, this.isFirstLevel);
    this.updateCurrentChildComponentType();
  }

  public validateType(type: string): boolean {
    switch (type.toLowerCase()) {
      case "file":
      case "number":
      case "numeric":
      case "money":
      case "text":
      case "email":
      case "hidden":
      case "textarea":
      case "date":
      case "datetime":
      case "boolean":
      case "checkbox":
      case "selectboxes":
      case "textfield":
      case "radio":
        return false;
      default:
        return true;
    }
  }

  public convertFieldTypeToDeterminantType(type: string, parent: string): string {
    console.log("convertFieldTypeToDeterminantType:", type, parent);
    if (!type) { return null; }
    switch (type.toLowerCase()) {
      case "editgrid":
      case "datagrid":
      case FieldType.GRID.toLowerCase():
        return FieldType.GRID;
      case "checkbox":
      case "boolean":
        return FieldType.BOOLEAN;
      case "button":
        return FieldType.BUTTON;
      case "number":
      case "numeric":
        return FieldType.NUMERIC;
      case "money":
        return FieldType.MONEY;
      case "text":
      case "textfield":
      case "email":
        return FieldType.TEXT;
      case "file":
        return FieldType.FILE;
      case "hidden":
        return FieldType.HIDDEN;
      case "select":
      case "classification":
        if (parent) {
          return FieldType.SUB_CATALOG;
        }
        return FieldType.CLASSIFICATION;
      case "radio":
        return FieldType.RADIO;
      case "datetime":
      case "date":
        return FieldType.DATE;
      case "grouping":
        return FieldType.GROUPING;
      case "selectboxes":
        return FieldType.SELECTBOXES;
      case "textarea":
        return FieldType.TEXTAREA;
      case "sub_catalog":
        return FieldType.SUB_CATALOG;
      default:
        return "";
    }
  }

  public updateClassificationFields(classificationFields: ClassificationField[]) {
    this.multipleClassificationFields = classificationFields;
    this.determinantResponse.emit(this.getDeterminant());
  }

  public operatorChanged(operator: GeneralOperatorType) {
    this.operator = operator;
    // Preserve operator when reloading field properties
    if (this.selectedField) {
      this.mapFieldSelectionValues(this.selectedField, true);
    }
    this.determinantResponse.emit(this.getDeterminant());
  }

  public classificationOperatorChanged(e: string) {
    console.log("classificationOperatorChanged:", e, this.isFirstLevel);
    if (ExtOperator.IS_VALID === e || ExtOperator.IS_NOT_VALID === e) {
      // @ts-ignore
      this.classificationOperator = e;
    } else {
      this.classificationOperator = SelectOperatorType[e];
    }
    if (this.determinantType === "FORMFIELD" || (!this.isFirstLevel && this.determinant?.fullKey?.includes("_collection_"))) {
      this.setFieldDeterminantTypeByKey(this.targetFormFieldKey);
      this.mapFieldSelectionValuesByKey(this.targetFormFieldKey, true);
    }
  }

  public textOperatorChanged(operator: TextOperatorType) {
    this.textOperator = operator;
    // Preserve operator when reloading field properties
    if (this.selectedField) {
      this.mapFieldSelectionValues(this.selectedField, true);
    }
    this.determinantResponse.emit(this.getDeterminant());
  }

  public selectOperatorChanged(operator: SelectOperatorType) {
    this.selectOperator = operator;
    // Preserve operator when reloading field properties
    if (this.selectedField) {
      this.mapFieldSelectionValues(this.selectedField, true);
    }
    this.determinantResponse.emit(this.getDeterminant());
  }

  public numericValueChanged(numericValue: any) {
    // console.log(numericValue);
    if (numericValue && numericValue.sourceFormFieldKey) {
      this.sourceFormFieldKey = numericValue.sourceFormFieldKey;
    } else {
      this.numericValue = numericValue.numericValue;
      this.sourceFormFieldKey = null;
    }
    this.determinantResponse.emit(this.getDeterminant());
  }

  public moneyValueChanged(moneyValue: any) {
    if (moneyValue && moneyValue.sourceFormFieldKey) {
      this.sourceFormFieldKey = moneyValue.sourceFormFieldKey;
    } else {
      this.moneyValue = moneyValue.moneyValue;
      this.sourceFormFieldKey = null;
    }
    this.determinantResponse.emit(this.getDeterminant());
  }

  public textValueChanged(textValue: any) {
    // console.log(textValue, this.determinant);
    if (textValue && textValue.sourceFormFieldKey) {
      this.sourceFormFieldKey = textValue.sourceFormFieldKey;
    } else {
      this.textValue = textValue.textValue;
      this.sourceFormFieldKey = null;
    }
    this.determinantResponse.emit(this.getDeterminant());
  }

  public dateValueChanged(dateValue: any) {
    if (dateValue && dateValue.sourceFormFieldKey) {
      this.sourceFormFieldKey = dateValue.sourceFormFieldKey;
    } else {
      this.dateValue = dateValue.dateValue;
      this.sourceFormFieldKey = null;
    }
    this.determinantResponse.emit(this.getDeterminant());
  }

  public selectValueChanged(selectValue: any) {
    if (selectValue && selectValue.sourceFormFieldKey) {
      this.sourceFormFieldKey = selectValue.sourceFormFieldKey;
    } else {
      this.selectValue = selectValue.selectValue;
      this.sourceFormFieldKey = null;
    }
    this.determinantResponse.emit(this.getDeterminant());
  }

  public booleanValueChanged(booleanValue: any) {
    if (booleanValue && typeof booleanValue === "object" && booleanValue.sourceFormFieldKey) {
      this.sourceFormFieldKey = booleanValue.sourceFormFieldKey;
    } else if (booleanValue && typeof booleanValue === "object") {
      this.booleanValue = booleanValue.booleanValue;
      this.sourceFormFieldKey = null;
    } else {
      this.booleanValue = booleanValue;
      this.sourceFormFieldKey = null;
    }
    this.determinantResponse.emit(this.getDeterminant());
  }

  public catalogGroupValueChanged(classificationGroup: ClassificationGroup) {
    this.classificationGroup = classificationGroup;
    this.determinantResponse.emit(this.getDeterminant());
  }

  public catalogValueChanged(catalogValue: any) {
    if (catalogValue && catalogValue.sourceFormFieldKey) {
      this.sourceFormFieldKey = catalogValue.sourceFormFieldKey;
    } else {
      this.classificationValue = catalogValue.catalogValue;
      this.sourceFormFieldKey = null;
    }
    this.determinantResponse.emit(this.getDeterminant());
  }

  public parentCatalogValueChanged(parentCatalogValue: ClassificationField) {
    this.parentCatalogValue = parentCatalogValue;
    this.determinantResponse.emit(this.getDeterminant());
  }

  public subCatalogValueChanged(subCatalogValue: ClassificationField) {
    this.subCatalogValue = subCatalogValue;
    this.determinantResponse.emit(this.getDeterminant());
  }

  public isCurrentDateChanged(isCurrentDate: boolean) {
    this.isCurrentDate = isCurrentDate;
    this.determinantResponse.emit(this.getDeterminant());
  }

  public subjectChanged(subject: SelectSubjectType) {
    this.subject = subject;
    this.determinantResponse.emit(this.getDeterminant());
  }

  public rowDeterminantChanged(rowDeterminant: Determinant) {
    if (rowDeterminant) {
      this.rowDeterminant = rowDeterminant;
      this.determinantResponse.emit(this.getDeterminant(FieldType.GRID));
    }
  }

  public updaDefaultOperator(isMultiple: boolean) {
    if (isMultiple) {
      this.operator = GeneralOperatorType.IN;
      this.textOperator = TextOperatorType.INCLUDES;
    } else {
      this.operator = GeneralOperatorType.EQUAL;
      this.textOperator = TextOperatorType.EQUAL;
    }
  }

  public getFieldProperties(field, isOperatorPreserved: boolean = false) {
    const selectionValues = [];
    this.parentClassificationTypeId = null;
    this.formControllerService.getFormField(this.serviceId, field.key).subscribe(
      (data) => {
        if (!data) {
          return;
        }
        field = data;
        this.isCatalogMultiple = field.multiple;
        if (!isOperatorPreserved) {
          this.updaDefaultOperator(this.isCatalogMultiple);
        }
        // console.log(field);
        if (field.dataSrcCatalog === "gdb") {
          this.gdbCatalog = field;
        };
        if (this.determinant && this.determinant.id) {
          this.fields = this.fields.filter((f) => {
            return f.type === field.type;
          });
        }
        //  = field.type;
        if (field.type === "select" && (field.catalog || (field.catalogIds && field.catalogIds[0]))) {
          this.fieldSelectionValues = selectionValues;
          this.fieldClassificationTypeId = field.catalog || (field.catalogIds && field.catalogIds[0]);
        } else if (field.type === "selectboxes") {
          field.values.forEach((item) => {
            selectionValues.push(item);
          });
          this.fieldSelectionValues = selectionValues;
        } else if (field.type === "radio") {
          field.values.forEach((item: any) => {
            selectionValues.push(item);
          });
          this.fieldSelectionValues = selectionValues;
        } else if (this.type === FieldType.GROUPING || (this.classificationOperator === SelectOperatorType.IN || this.classificationOperator === SelectOperatorType.NOT_IN)) {
          this.parentClassificationTypeId = null;
          this.type = FieldType.GROUPING;
          const parentClassificationFieldKeyValues = field.parentCatalogField ? field.parentCatalogField.split(".") : null;
          if (parentClassificationFieldKeyValues && parentClassificationFieldKeyValues.length === 3) {
            field.classificationType = parentClassificationFieldKeyValues[1];
            this.fieldClassificationTypeId = field.classificationType;
            field.parentClassificationFieldKey = parentClassificationFieldKeyValues[2];
          }
          this.allFields.some((f) => {
            // console.log(f.key, field.parentClassificationFieldKey);
            if (f.key === field.parentClassificationFieldKey) {
              console.log("FOUND PARENT CATALOG", f, this.isFirstLevel);
              this.parentClassificationTypeId = f.catalog || (f.catalogIds && f.catalogIds[0]);
              return true;
            }
          });
        } else if (field.type === "select" && field.parentCatalogField) {
          this.fieldClassificationTypeId = null;
          this.parentClassificationTypeId = null;
          if (field.classificationType) {
            this.fieldClassificationTypeId = field.classificationType;
            this.type = this.type || field.inputType;
          }
          const parentClassificationFieldKeyValues = field.parentCatalogField.split(".");
          if (parentClassificationFieldKeyValues && parentClassificationFieldKeyValues.length === 3) {
            field.parentClassificationFieldKey = parentClassificationFieldKeyValues[2];
            this.type = FieldType.SUB_CATALOG;
            this.allFields.forEach((f) => {
              if (f.key === field.parentClassificationFieldKey) {
                this.parentClassificationTypeId = f.catalog || f.catalogIds[0];
              }
            });
          }
          if (field.data && field.data.values && field.data.values.length > 0) {
            field.data.values.forEach((item: any) => {
              const selectValue = new ClassificationField();
              selectValue.id = item.value;
              selectValue.value = item.label;
              selectionValues.push(selectValue);
            });
            this.fieldSelectionValues = selectionValues;
          }
        }
        // console.log("--- getFieldProperties --- ", field, data, this.type, this.fieldSelectionValues);
        console.log("--- getFieldProperties --- ", field, data, this.type, this.fieldSelectionValues, this.isFirstLevel);
      },
    );
  }

  public getDeterminant(detType: any = this.type): Determinant {
    // console.log("-- getDeterminant", detType);
    // Check for new event determinants first (discriminated by event name properties)
    if (this.buttonEventName !== undefined) {
      const det: ButtonDeterminant = new ButtonDeterminant();
      det.id = this.id;
      det.name = this.name;
      det.type = this.type;
      det.buttonEventName = this.buttonEventName;
      det.buttonKey = this.buttonKey;
      det.targetFormFieldKey = this.targetFormFieldKey;
      det.determinantType = this.determinantType;
      det.serviceId = this.serviceId;
      return det;
    } else if (this.fileUploadEventName !== undefined) {
      const det: FileUploadDeterminant = new FileUploadDeterminant();
      det.id = this.id;
      det.name = this.name;
      det.type = this.type;
      det.fileUploadEventName = this.fileUploadEventName;
      det.fileUploadKey = this.fileUploadKey;
      det.targetFormFieldKey = this.targetFormFieldKey;
      det.determinantType = this.determinantType;
      det.serviceId = this.serviceId;
      return det;
    } else if (this.gridEventName !== undefined) {
      const det: GridComponentDeterminant = new GridComponentDeterminant();
      det.id = this.id;
      det.name = this.name;
      det.type = this.type;
      det.gridEventName = this.gridEventName;
      det.gridKey = this.gridKey;
      det.targetFormFieldKey = this.targetFormFieldKey;
      det.determinantType = this.determinantType;
      det.serviceId = this.serviceId;
      return det;
    } if (detType) {
      if (detType.toUpperCase() === FieldType.BOOLEAN) {
        const det: BooleanDeterminant = new BooleanDeterminant();
        det.id = this.id;
        det.name = this.name;
        det.type = detType;
        det.targetFormFieldKey = this.targetFormFieldKey;
        det.targetFormFieldJsonPath = this.targetFormFieldJsonPath;
        det.sourceFormFieldKey = this.sourceFormFieldKey;
        det.determinantType = this.determinantType;
        det.booleanValue = this.booleanValue;
        det.serviceId = this.serviceId;
        return det;
      } else if (detType.toUpperCase() === FieldType.BUTTON) {
        const det: ButtonDeterminant = new ButtonDeterminant();
        det.id = this.id;
        det.name = this.name;
        det.type = detType;
        det.buttonEventName = this.buttonEventName;
        det.buttonKey = this.buttonKey;
        det.targetFormFieldKey = this.targetFormFieldKey;
        det.determinantType = this.determinantType;
        det.serviceId = this.serviceId;
        return det;
      } else if (detType.toUpperCase() === FieldType.NUMERIC) {
        const det: NumericDeterminant = new NumericDeterminant();
        det.id = this.id;
        det.name = this.name;
        det.type = detType;
        det.operator = this.operator as any;
        det.numericValue = this.numericValue;
        det.sourceFormFieldKey = this.sourceFormFieldKey;
        det.targetFormFieldKey = this.targetFormFieldKey;
        det.targetFormFieldJsonPath = this.targetFormFieldJsonPath;
        det.determinantType = this.determinantType;
        det.serviceId = this.serviceId;
        return det;
      } else if (detType.toUpperCase() === FieldType.MONEY) {
        const det: MoneyDeterminant = new MoneyDeterminant();
        det.id = this.id;
        det.name = this.name;
        det.type = detType;
        det.operator = this.operator as GeneralOperatorType;
        det.moneyValue = this.moneyValue;
        det.targetFormFieldKey = this.targetFormFieldKey;
        det.targetFormFieldJsonPath = this.targetFormFieldJsonPath;
        det.sourceFormFieldKey = this.sourceFormFieldKey;
        det.determinantType = this.determinantType;
        det.serviceId = this.serviceId;
        return det;
      } else if (detType.toUpperCase() === FieldType.TEXT || detType.toUpperCase() === FieldType.TEXTAREA || detType.toUpperCase() === FieldType.TEXTFIELD) {
        const det: TextDeterminant = new TextDeterminant();
        det.id = this.id;
        det.name = this.name;
        det.type = FieldType.TEXT;
        det.operator = this.textOperator;
        det.textValue = this.textValue ? this.textValue : "";
        det.targetFormFieldKey = this.targetFormFieldKey;
        det.targetFormFieldJsonPath = this.targetFormFieldJsonPath;
        det.sourceFormFieldKey = this.sourceFormFieldKey;
        det.determinantType = this.determinantType;
        det.serviceId = this.serviceId;
        return det;
      } else if (detType.toUpperCase() === FieldType.FILE) {
        const det: FileDeterminant = new FileDeterminant();
        det.id = this.id;
        det.name = this.name;
        det.type = FieldType.FILE;
        det.operator = this.textOperator;
        det.targetFormFieldKey = this.targetFormFieldKey;
        det.targetFormFieldJsonPath = this.targetFormFieldJsonPath;
        det.sourceFormFieldKey = this.sourceFormFieldKey;
        det.determinantType = this.determinantType;
        det.serviceId = this.serviceId;
        return det;
      } else if (detType.toUpperCase() === FieldType.HIDDEN) {
        const det: TextDeterminant = new TextDeterminant();
        det.id = this.id;
        det.name = this.name;
        det.type = FieldType.HIDDEN;
        det.operator = this.textOperator;
        det.textValue = this.textValue;
        det.targetFormFieldKey = this.targetFormFieldKey;
        det.targetFormFieldJsonPath = this.targetFormFieldJsonPath;
        det.sourceFormFieldKey = this.sourceFormFieldKey;
        det.determinantType = this.determinantType;
        det.serviceId = this.serviceId;
        return det;
      } else if (detType.toUpperCase() === FieldType.RADIO) {
        const det: RadioDeterminant = new RadioDeterminant();
        det.id = this.id;
        det.name = this.name;
        det.type = FieldType.RADIO;
        det.operator = this.selectOperator;
        det.selectValue = this.selectValue;
        det.targetFormFieldKey = this.targetFormFieldKey;
        det.targetFormFieldJsonPath = this.targetFormFieldJsonPath;
        det.sourceFormFieldKey = this.sourceFormFieldKey;
        det.determinantType = this.determinantType;
        det.serviceId = this.serviceId;
        return det;
      } else if (detType.toUpperCase() === FieldType.SELECTION) {
        const det: SelectDeterminant = new SelectDeterminant();
        det.id = this.id;
        det.name = this.name;
        det.type = FieldType.SELECTION;
        det.operator = this.selectOperator;
        det.selectValue = this.selectValue;
        det.targetFormFieldKey = this.targetFormFieldKey;
        det.targetFormFieldJsonPath = this.targetFormFieldJsonPath;
        det.sourceFormFieldKey = this.sourceFormFieldKey;
        det.determinantType = this.determinantType;
        det.serviceId = this.serviceId;
        return det;
      } else if (detType.toUpperCase() === FieldType.SELECTBOXES) {
        const det: SelectBoxesDeterminant = new SelectBoxesDeterminant();
        det.id = this.id;
        det.name = this.name;
        det.type = FieldType.SELECTBOXES;
        det.targetFormFieldKey = this.targetFormFieldKey + "_child_" + this.selectValue;
        det.targetFormFieldJsonPath = this.targetFormFieldJsonPath;
        det.sourceFormFieldKey = this.sourceFormFieldKey;
        det.selectValue = this.selectValue;
        det.determinantType = this.determinantType;
        det.operator = this.selectOperator;
        det.serviceId = this.serviceId;
        det.booleanValue = this.booleanValue;
        return det;
      } else if (detType.toUpperCase() === FieldType.DATE) {
        const det: DateDeterminant = new DateDeterminant();
        det.id = this.id;
        det.name = this.name;
        det.type = FieldType.DATE;
        det.operator = this.operator as GeneralOperatorType;
        det.dateValue = this.dateValue;
        det.isCurrentDate = this.isCurrentDate;
        det.targetFormFieldKey = this.targetFormFieldKey;
        det.targetFormFieldJsonPath = this.targetFormFieldJsonPath;
        det.sourceFormFieldKey = this.sourceFormFieldKey;
        det.determinantType = this.determinantType;
        det.serviceId = this.serviceId;
        return det;
      } else if ((detType.toUpperCase() === FieldType.GROUPING) && (this.classificationOperator !== SelectOperatorType.EQUAL && this.classificationOperator !== SelectOperatorType.NOT_EQUAL)) {
        const det: GroupingDeterminant = new GroupingDeterminant();
        det.id = this.id;
        det.name = this.name;
        det.type = FieldType.GROUPING;
        det.subject = this.subject;
        det.operator = this.classificationOperator;
        det.classificationTypeId = this.fieldClassificationTypeId;
        det.targetFormFieldKey = this.targetFormFieldKey;
        det.targetFormFieldJsonPath = this.targetFormFieldJsonPath;
        det.sourceFormFieldKey = this.sourceFormFieldKey;
        det.classificationGroup = this.classificationGroup;
        det.classificationFields = this.multipleClassificationFields;
        det.determinantType = this.determinantType;
        det.serviceId = this.serviceId;
        det.classificationField = this.parentCatalogValue;
        return det;
      } else if ((detType.toUpperCase() === FieldType.CLASSIFICATION) || (detType.toUpperCase() === FieldType.GROUPING && (this.classificationOperator === SelectOperatorType.EQUAL || (this.classificationOperator === SelectOperatorType.NOT_EQUAL)))) {
        const det: ClassificationDeterminant = new ClassificationDeterminant();
        det.id = this.id;
        det.name = this.name;
        det.type = FieldType.CLASSIFICATION;
        det.subject = this.subject;
        det.operator = this.classificationOperator;
        det.classificationField = this.classificationValue;
        det.classificationFieldIds = this.multipleClassificationFields;
        det.targetFormFieldKey = this.targetFormFieldKey;
        det.targetFormFieldJsonPath = this.targetFormFieldJsonPath;
        det.sourceFormFieldKey = this.sourceFormFieldKey;
        det.determinantType = this.determinantType;
        det.classificationGroup = this.classificationGroup;
        if (this.gdbCatalog && this.gdbCatalog.gdbCatalogValue) {
          det.gdbCatalogSelectedValue = this.classificationValue?.key;
          det.gdbCatalogFieldId = this.gdbCatalog.gdbCatalogValue.id;
          det.gdbCatalogValue = this.gdbCatalog.gdbCatalogValue;
        }
        det.serviceId = this.serviceId;
        return det;
      } else if (detType.toUpperCase() === FieldType.SUB_CATALOG) {
        const det: SubCatalogDeterminant = new SubCatalogDeterminant();
        det.id = this.id;
        det.name = this.name;
        det.type = FieldType.SUB_CATALOG;
        det.operator = this.classificationOperator;
        det.parentCatalogField = this.parentCatalogValue;
        det.classificationFieldIds = this.multipleClassificationFields;
        det.subCatalogField = this.subCatalogValue;
        det.targetFormFieldKey = this.targetFormFieldKey;
        det.targetFormFieldJsonPath = this.targetFormFieldJsonPath;
        det.subject = this.subject;
        det.sourceFormFieldKey = this.sourceFormFieldKey;
        det.determinantType = this.determinantType;
        det.serviceId = this.serviceId;
        return det;
      } else if (detType.toUpperCase() === FieldType.GRID) {
        const det: GridDeterminant = new GridDeterminant();
        det.id = this.id;
        det.name = this.name;
        det.type = FieldType.GRID;
        det.subject = this.subject;
        det.subject = this.subject;
        det.rowDeterminant = _.cloneDeep(this.rowDeterminant);
        det.rowDeterminant.targetFormFieldKey = this.selectedField.fullKey;
        det.rowDeterminant.determinantType = String(DeterminantType.FORMFIELD);

        det.targetFormFieldKey = this.targetFormFieldKey;
        det.targetFormFieldJsonPath = this.targetFormFieldJsonPath;
        det.sourceFormFieldKey = this.sourceFormFieldKey;
        det.determinantType = this.determinantType;
        det.serviceId = this.serviceId;
        det.determinantInsideGrid = this.gridContext === "inside same grid";
        // console.log(det, this.rowDeterminant);
        return det;
      }
    }
  }

  public mapFieldSelectionValuesByKey(key: string, preserveOperator: boolean = false) {
    if (this.fields) {
      this.fields.some((field) => {
        if (field.key === key || field.fullKey === key) {
          this.mapFieldSelectionValues(field, preserveOperator);
          return true;
        }
      });
    }
  }

  public mapFieldSelectionValues(field: any, preserveOperator: boolean = false) {
    console.log("---- mapFieldSelectionValues", field, this.isFirstLevel);
    // console.log("--- mapFieldSelectionValues ---", field);
    if (field) { this.getFieldProperties(field, preserveOperator); }
    Store.callUglyAngularRedraw();
  }

  public onTargetFormFieldKeyChange(event: string): void {
    console.log("---- onTargetFormFieldKeyChange event:", event, this.isFirstLevel);
    if (typeof event === "object") {
      return;
    }
    // console.log(event);
    const obj = this.fields.find((item) => item.key === event);
    if (obj) {
      console.log("---- onTargetFormFieldKeyChange", obj, this.isFirstLevel);
      this.selectedField = obj;
      this.updateCurrentChildComponentType();
      this.targetFormFieldJsonPath = obj.jsonPath;
      this.targetFormFieldKey = event;
      const fullKey = obj.fullKey?.replace("_collection_item", "");
      this.isFromGrid = fullKey?.includes("_collection_");
      if (this.isFromGrid) {
        if (this.rowDeterminant) {
          this.rowDeterminant.targetFormFieldKey = obj.fullKey;
        } else {
          this.rowDeterminant = obj;
        }

        this.targetFormFieldKey = fullKey?.split("_collection_")[0];

        // Initialize gridContext if not already set
        if (!this.gridContext) {
          this.gridContext = "inside same grid";
        }
      }

      // Auto-trigger event determinants based on field type
      // Only set grid event for top-level grids, not for grids inside other grids
      // (grids inside grids should show the "outside the grid" context UI instead)
      if ((obj.type === "editgrid" || obj.type === "datagrid") && !this.isFromGrid) {
        this.gridEventName = "";
        this.gridKey = obj.key;
        this.buttonEventName = undefined;
        this.buttonKey = undefined;
        this.fileUploadEventName = undefined;
        this.fileUploadKey = undefined;
      } else if (obj.type === "button") {
        this.buttonEventName = "click";
        this.buttonKey = obj.key;
        this.gridEventName = undefined;
        this.gridKey = undefined;
        this.fileUploadEventName = undefined;
        this.fileUploadKey = undefined;
      } else if (obj.type === "file" && !this.isFromGrid) {
        // Only set file upload event if NOT inside a grid
        // File fields in grids should show grid context UI instead
        this.fileUploadEventName = "change";
        this.fileUploadKey = obj.key;
        this.gridEventName = undefined;
        this.gridKey = undefined;
        this.buttonEventName = undefined;
        this.buttonKey = undefined;
      } else {
        // Reset all event properties when switching to standard fields
        this.gridEventName = undefined;
        this.gridKey = undefined;
        this.buttonEventName = undefined;
        this.buttonKey = undefined;
        this.fileUploadEventName = undefined;
        this.fileUploadKey = undefined;
      }
    } else {
      this.type = null;
      this.isFromGrid = false;
      this.gridContext = null;
      this.selectedField = null;
      this.updateCurrentChildComponentType();
      this.targetFormFieldKey = event;
      // Reset all event determinant properties
      this.gridEventName = undefined;
      this.gridKey = undefined;
      this.buttonEventName = undefined;
      this.buttonKey = undefined;
      this.fileUploadEventName = undefined;
      this.fileUploadKey = undefined;
    }

    this.classificationGroup = null;
    this.parentClassificationTypeId = null;
    this.setFieldDeterminantType(obj);
    this.mapFieldSelectionValues(obj, true);
    this.determinantResponse.emit(this.getDeterminant());
  }

  public getGridSubjects(): any[] {
    return [SelectSubjectType.ALL, SelectSubjectType.NONE, SelectSubjectType.SOME];
  }

  public buttonEventNameChanged(eventName: string) {
    this.buttonEventName = eventName;
    this.determinantResponse.emit(this.getDeterminant());
  }

  public buttonKeyChanged(key: string) {
    this.buttonKey = key;
    this.determinantResponse.emit(this.getDeterminant());
  }

  public fileUploadEventNameChanged(eventName: string) {
    this.fileUploadEventName = eventName;
    this.determinantResponse.emit(this.getDeterminant());
  }

  public fileUploadKeyChanged(key: string) {
    this.fileUploadKey = key;
    this.determinantResponse.emit(this.getDeterminant());
  }

  public gridEventNameChanged(eventName: string) {
    this.gridEventName = eventName;
    this.determinantResponse.emit(this.getDeterminant());
  }

  public gridKeyChanged(key: string) {
    this.gridKey = key;
    this.determinantResponse.emit(this.getDeterminant());
  }

  public readonly SelectOperatorType = SelectOperatorType;
}
